var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-inner"},[_c('div',[_c('div',[_vm._v("产品服务池")]),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("来这里寻找你想要的产品吧")])]),_c('div',{staticStyle:{"padding-top":"20px"}},[_c('img',{staticStyle:{"width":"500px","height":"280px"},attrs:{"src":require("../assets/images/productHead.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }